/** Gari la mchanga — Tanzania default (~7 tone; badilisha ikiwa kiwanda chako ni tofauti). */
export const DEFAULT_TONNES_PER_LORRY = 7;

export function tonnesPerLorry(configValue) {
  const n = Number(configValue);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_TONNES_PER_LORRY;
}

export function normalizeStockUnit(unit) {
  const u = String(unit || 'tonne').toLowerCase().trim();
  if (u === 'lorry' || u === 'lori' || u === 'gari') return 'lorry';
  if (u === 'kg') return 'kg';
  return 'tonne';
}

/** Stock quantity → tonnes (handles lori, kg, tone). */
export function stockQuantityToTonnes(qty, unit, tPerLorry = DEFAULT_TONNES_PER_LORRY) {
  const n = Number(qty) || 0;
  const u = normalizeStockUnit(unit);
  if (u === 'lorry') return n * tPerLorry;
  if (u === 'kg') return n / 1000;
  return n;
}

export function tonnesToStockQuantity(tonnes, unit, tPerLorry = DEFAULT_TONNES_PER_LORRY) {
  const t = Number(tonnes) || 0;
  const u = normalizeStockUnit(unit);
  if (u === 'lorry') return t / tPerLorry;
  if (u === 'kg') return t * 1000;
  return t;
}

function trimQty(value, decimals = 3) {
  const formatted = Number(value).toFixed(decimals);
  return formatted.replace(/\.?0+$/, '') || '0';
}

/** Human line: "3 lori (≈21 tone)" or "15 tone". */
export function formatSandStockAvailability(product, tPerLorry = DEFAULT_TONNES_PER_LORRY) {
  if (!product) return null;
  const unit = normalizeStockUnit(product.unit);
  const qty = Number(product.quantity) || 0;
  const tonnes = stockQuantityToTonnes(qty, unit, tPerLorry);

  if (unit === 'lorry') {
    const lorries = trimQty(qty, 2);
    return `${lorries} lori (≈ ${trimQty(tonnes)} tone @ ${tPerLorry}t/ lori)`;
  }
  if (unit === 'kg') {
    return `${trimQty(qty)} kg (≈ ${trimQty(tonnes)} tone)`;
  }
  const lorries = trimQty(tonnes / tPerLorry, 2);
  return `${trimQty(qty)} tone (≈ ${lorries} lori)`;
}

export function formatSandUsageLine(tonnesNeeded, tPerLorry = DEFAULT_TONNES_PER_LORRY) {
  const t = Number(tonnesNeeded) || 0;
  if (t <= 0) return '—';
  const lorries = trimQty(t / tPerLorry, 2);
  return `${trimQty(t)} tone (≈ ${lorries} lori)`;
}
